







































































































































import Debug from 'debug'
import { Vue, Component } from 'vue-property-decorator';
import { AspectSelectInfo, File, Term } from '@/app/shared/models';
import { uniqueId } from 'lodash';
import { setFocus } from '@/app/accessibility/accessibility-utils';
import { lazyInject } from '@/app/container';
import { FileBankService, FileBankServiceSymbol } from '@/app/file/file-bank-service';
import { TermsByLetterAndTopic, TermService, TermServiceSymbol } from '@/app/term/term-service';
import { createEvent, EventStream, EventStreamSymbol } from '@/app/event-stream';
import { AspectInstanceChangedEvent, AspectInstanceChangedEventName } from '@/app/aspect/events/aspect-events';
import { AspectService, AspectServiceSymbol } from '@/app/aspect/aspect-service';
import rootModule from '@/app/shared/state/root';
import aspectStoreModule from '@/app/aspect/apsect-state';
import LocaleSelectorComponent from '@/app/shared/components/locale-selector-component.vue';
import TermsComponent from '@/app/shared/components/terms-component.vue';
import DocumentsComponent from '@/app/shared/components/documents-component.vue';
import WrapperModalComponent from '@/app/shared/components/wrapper/wrapper-modal-component.vue';
import AspectComponent from '@/app/aspect/components/aspect-component.vue';
import { resolveVersion } from '@/app/version'
import AspectMenuComponent from '@/app/aspect/components/aspect-menu-component.vue';
import { SerializedAspectValueDescriptor } from '@xlearn/common';
import { restrictedThemes } from '@/app/shared/utils'

const debug = Debug('header-component')

@Component({
  components: {
    LocaleSelectorComponent,
    TermsComponent,
    DocumentsComponent,
    WrapperModalComponent,
    AspectComponent,
    AspectMenuComponent
  }
})
export default class HeaderComponent extends Vue {
  private headerIsOpenInternal: boolean = false;
  private storeType: string = '';
  private showsStoreModal: boolean = false;
  private showsAspectModal: boolean = false;
  private showsReportTooltip: boolean = false;
  private reportEmail = this.getEmail;
  private savedAspectId: string | null = null;
  private selectedAspectNumber: number = -1;
  private isAspectMenuVisible: boolean = false;
  private showNistifyThemeElements: boolean = false;
  private showVGYEThemeElements: boolean = false;

  @lazyInject(FileBankServiceSymbol)
  private fileBankService: FileBankService;

  @lazyInject(TermServiceSymbol)
  private termService: TermService;

  @lazyInject(AspectServiceSymbol)
  private aspectService: AspectService;

  @lazyInject(EventStreamSymbol)
  private eventStream: EventStream;

  async mounted() {
    debug('mounted');
    if (aspectStoreModule.shouldUserSelectAspect) {
      debug('displaying aspect model');
      this.showsAspectModal = true
    }
    this.savedAspectId = aspectStoreModule.selectedAspectInstanceId

    if (restrictedThemes(['nistify'])) {
      this.showNistifyThemeElements = true;
    }

    if (restrictedThemes(['vgye'])) {
      this.showVGYEThemeElements = true;
    }
  }

  private get savedId(): string |null {
    return this.savedAspectId
  }

  private set selectedAspect(aspect: number) {
    this.selectedAspectNumber = aspect
  }

  private get selectedAspect(): number {
    return this.selectedAspectNumber
  }

  private get versionText(): string {
    const versionInfo = resolveVersion()
    let text = `v${versionInfo.package.version}`
    if (versionInfo.date) {
      const date = versionInfo.date
      const dateText = date.getFullYear() +
            ("0"+(date.getMonth()+1)).slice(-2) +
            ("0"+(date.getDate())).slice(-2)

      text += ` (${dateText})`
    }
    return text
  }

  private get sidebarIsOpen(): boolean {
    return rootModule.sidebarIsOpen;
  }

  private set sidebarIsOpen(value: boolean) {
    rootModule.setSidebarIsOpen(value);
  }

  private get headerIsOpen(): boolean {
    return this.headerIsOpenInternal;
  }

  private set headerIsOpen(value: boolean) {
    this.headerIsOpenInternal = value;
  }

  private get isPageRoute(): boolean {
    return this.$route.name === 'page';
  }

  private get termsModalLinkId(): string {
    return uniqueId('terms-modal-link-');
  }

  private get documentsModalLinkId(): string {
    return uniqueId('documents-modal-link-');
  }

  private get aspects(): AspectSelectInfo[]|null {
    return aspectStoreModule.aspects;
  }

  private get pdfUri(): string|null {
    if (!aspectStoreModule.selectedCourseAspectInstance) {
      return null;
    }

    return aspectStoreModule.selectedCourseAspectInstance.pdfUri;
  }

  private get hasSearch(): boolean {
    if (!aspectStoreModule.selectedCourseAspectInstance) {
      return false;
    }

    const selected = aspectStoreModule.selectedCourseAspectInstance
    if (selected.search && selected.search.entries.length > 0) {
      return true
    }

    return false
  }

  private get isTermsModalOpen(): boolean {
    return this.showsStoreModal && this.storeType === 'definitions';
  }

  private get isDocumentsModalOpen(): boolean {
    return this.showsStoreModal && this.storeType === 'documents';
  }

  private get allFiles(): File[] {

    const allFiles = this.fileBankService.getFiles()

    let uniqueFiles: File[] = [];

    allFiles.forEach(file =>{
      let found = false
      uniqueFiles.forEach(element => {
        if ((element.originalFilename === file.originalFilename) && (element.title === file.title)) found = true
      });
      if (!found) uniqueFiles.push(file)
    })
    return uniqueFiles;
  }

  private get allTerms(): TermsByLetterAndTopic {
    return this.termService.termsByLetterAndTopicId(this.aspectTerms);
  }

  private get getEmail(): string {
    if (restrictedThemes(['minerva'])) {
      return 'elearning@otpbank.hu'
    }
    if (restrictedThemes(['mekh'])) {
      return 'nccs@mekh.hu'
    }
    if (restrictedThemes(['iom'])) {
      return 'rmmmeandreporting@iom.int'
    }
    return 'bugs@skillgo.io';
  }

  private get aspectTerms(): Term[] {
    if (!aspectStoreModule.selectedCourseAspectInstance) {
      return [];
    }

    return aspectStoreModule.selectedCourseAspectInstance.terms;
  }

  private get showReport(): boolean {
    return !restrictedThemes(['mavir', 'mavir-orange', 'mvm'])
  }

  private get showGlossary(): boolean {
    return !restrictedThemes(['mekh'])
  }

  private get textOnlyReportLabel(): boolean {
    return restrictedThemes(['eucom'])
  }

  private get errorReportText()  {
    if (restrictedThemes(['bm'])) {
      return "Belügyminisztérium"
    }


    if (restrictedThemes(['eucom'])) {
      const emailAddress = 'HADEA-BTSF-ACADEMY-SUPPORT@ec.europa.eu'
      const buildVersion = this.versionText
      return `If you need help or have a technical issue with this course, please contact us at <a class=\"mailto\" href=\"mailto:${emailAddress}?&subject=Error%20Report%20-%20${buildVersion}\">${emailAddress}</a>. <span class=\"version-text\">${buildVersion}</span>`
    }

    return this.$t('player.error_report_text', { buildVersion: this.versionText, emailAddress: this.reportEmail })
  }

  private get errorReportLabel() {
    if (restrictedThemes(['eucom'])) {
      return 'Help'
    }
    return this.$t('player.error_report')
  }

  private getSelectedAspect(aspect: AspectSelectInfo, level: number):SerializedAspectValueDescriptor | null {
    if (!this.savedAspectId) {
      return null
    }

    const savedAspectIds = this.savedAspectId.split('-')
    let foundValue:SerializedAspectValueDescriptor | undefined

    aspect.values.forEach(aspectId => {
      if (savedAspectIds[level] === aspectId.id) {
          foundValue = aspectId
        }
      })

    if (!foundValue){
      return null
    }
    return foundValue
  }

  private getSelectedAspectName(aspect: AspectSelectInfo, level: number) {
    const foundAspect = this.getSelectedAspect(aspect, level)
    if (foundAspect){
      return foundAspect.name
    } else {
      return this.$t('player.no_selected_aspect')
    }
  }

  private handleSelectedAspect( aspect: { id: string, level: number }) {
    this.hideAspectMenu()

    this.selectedAspect = -1
    if (!this.savedAspectId) {
      return
    }

    const items = this.savedAspectId.split('-')
    items[aspect.level] = aspect.id
    this.savedAspectId = items.join('-')

    this.changeAspect(this.savedAspectId)
  }

  private showStoreModal(storeType: string) {
    if (this.showsStoreModal && this.storeType === storeType) {
      this.closeStoreModal();
      return;
    }

    if (this.showsAspectModal) {
      this.closeAspectModal();
    }

    this.storeType = storeType;
    this.showsStoreModal = true;
    this.headerIsOpenInternal = false;
  }

  private closeStoreModal(linkId: string|null = null) {
    this.showsStoreModal = false;
    this.headerIsOpenInternal = false;

    if (linkId !== null) {
      setFocus(`#${linkId}`);
    }
  }

  // private showAspectModal() {
  //   if (this.showsStoreModal) {
  //     this.closeStoreModal();
  //   }

  //   if (this.showsAspectModal) {
  //     this.closeAspectModal();
  //     return;
  //   }

  //   this.showsAspectModal = true;
  //   this.headerIsOpenInternal = false;
  // }

  private async changeAspect(aspectInstanceId: string): Promise<void> {
    const changedEvent = createEvent<typeof AspectInstanceChangedEventName, AspectInstanceChangedEvent>(
      AspectInstanceChangedEventName, {
        instanceId: aspectInstanceId
      }
    );
    this.eventStream.dispatch(changedEvent);

    await this.aspectService.set(aspectInstanceId, false);

    this.closeAspectModal();

    this.savedAspectId = aspectInstanceId

    const onDashboard: boolean = this.$router.currentRoute.name === 'dashboard';
    if (!onDashboard) {
      await this.$router.push({ name: 'dashboard' });
    }
  }

  private closeAll() {
    this.showsStoreModal = false;
    this.showsAspectModal = false;
    this.headerIsOpenInternal = false;
  }

  private closeAspectModal() {
    this.showsAspectModal = false;
    this.headerIsOpenInternal = false;
  }

  private toggleAspectMenu(index: number) {
    if (this.isAspectMenuVisible) {
      this.isAspectMenuVisible = false
      return
    }

    this.isAspectMenuVisible = true
    this.selectedAspect = index
  }

  private hideAspectMenu() {
    this.isAspectMenuVisible = false
  }
}
